export const CHECKOUT_LINKS = {
  training: 'https://pay.cakto.com.br/pj4beet_993210',
};

// URL pública do aplicativo (PWA) — destino do botão "ACESSAR GRATUITAMENTE"
export const APP_URL = 'https://aguia-transform.emergent.host';

export const PRICING = {
  training: { oldPrice: 'R$ 39,90', price: 'R$ 10,90', suffix: '' },
};

export const CONTACT_EMAIL = 'contato@despertardaaguia.com.br';

export const BRAND = 'Despertar da Águia';
